import { useParams } from "react-router-dom";
import { FiFileText } from "react-icons/fi";

import { actions, hasPermission } from "../../services/security";

import Card from "./../../Components/ui/card";
import Header from "./../../Components/ui/header";
import PlantillasForm from "../../Components/plantillas/Plantillas-form";
import PlantillasFormDetails from "../../Components/plantillas/Plantillas-form-details";

const PlantillaDetailPage = () => {
  const { id } = useParams();

  const action =
    id === "nuevo"
      ? "Crear"
      : hasPermission(actions.PlantillasEditar)
        ? "Editar"
        : "Ver";

  const title = `${action} Plantilla`;
  const icon = <FiFileText />;
  const breadcrumb = [
    { title: "Plantilla", url: "/plantillas" },
    { title: action, url: `/plantillas/${id}` },
  ];



  if (id === "nuevo") {
    return (
      <Card>
        <Header title={title} icon={icon} breadcrumb={breadcrumb} />
        <PlantillasForm id={id} />
      </Card>
    );
  }

  else {
    return (
      <Card>
        <Header title={title} icon={icon} breadcrumb={breadcrumb} />
        <PlantillasFormDetails id={id} />
      </Card>
    );
  }

};

export default PlantillaDetailPage;
